// extracted by mini-css-extract-plugin
module.exports = {"collection":"ConsentsCollection_collection__XwfEr","item":"ConsentsCollection_item__1dNYu","header":"ConsentsCollection_header__1Pfiz"};